<template>
  <div class="filter-container">
    <div class="filter-container-header">
      <div class="filter-container-result">
        <div class="filter-container-result__title">
          Search results for "<span class="filter-container-result__keyword">{{ filter.keyword ?? categoryName }}</span>"
        </div>
      </div>
    </div>
  </div>
  <div class="filter-controls">
    <Filter
      v-model:sort="filter.sortMap"
      v-model:price-start="filter.priceStart"
      v-model:price-end="filter.priceEnd"
      @done="onReset"
    />
    <PriceTip class="filter-controls__tip" />
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { useProductList } from '../../hooks/useProductList'
import { Filter, PriceTip } from '@/components/Filter'
import { TRANSLATE_MAP } from '@/utils/constants'
import { useLanguageStore } from '@/pinia/language'

const route = useRoute()
const language = useLanguageStore()
const { filter, onReset } = useProductList()
const categoryName = computed(() => {
  return TRANSLATE_MAP[language.current]?.[route.params.category]
})

watch(() => filter.sortMap, (val) => {
  onReset()
})
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
